import axios from 'axios';
import { ObjectType } from 'src/types/types';

const createAxios = (apiURL: string, headers: ObjectType = {}, params: ObjectType = {}) => {
    return axios.create({ baseURL: `${apiURL}/`, ...params, headers: headers });
};

export {
    createAxios,
};